import * as userTypes from "../../types/admin/userTypes";

const initialState = {
  loading: false,
  info: null,
  error: null,
};

export const createUserReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case userTypes.CREATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case userTypes.CREATE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateUserReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case userTypes.UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userTypes.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case userTypes.UPDATE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateUserAuthReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case userTypes.UPDATE_USER_AUTH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userTypes.UPDATE_USER_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case userTypes.UPDATE_USER_AUTH_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const userReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case userTypes.GET_ONE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case userTypes.GET_ONE_USER_SUCCESS:
      return { ...state, loading: false, info: payload, error: null };
    case userTypes.GET_ONE_USER_FAIL:
      return { ...state, loading: false, info: null, error: payload };
    default:
      return state;
  }
};

export const userAuthReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case userTypes.GET_ONE_USER_AUTH_REQUEST:
      return { ...state, loading: true, error: null };
    case userTypes.GET_ONE_USER_AUTH_SUCCESS:
      return { ...state, loading: false, info: payload, error: null };
    case userTypes.GET_ONE_USER_AUTH_FAIL:
      return { ...state, loading: false, info: null, error: payload };
    default:
      return state;
  }
};

export const getAllUserReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case userTypes.GET_ALL_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case userTypes.GET_ALL_USER_SUCCESS:
      return { ...state, loading: false, info: payload, error: null };
    case userTypes.GET_ALL_USER_FAIL:
      return { ...state, loading: false, info: null, error: payload };
    default:
      return state;
  }
};


export const updateUserStatusReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case userTypes.UPDATE_USER_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userTypes.UPDATE_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case userTypes.UPDATE_USER_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};